
import { Component, Vue, Prop } from "vue-property-decorator";
import { TNote_Table, TNote } from "@/models/case_notes";
import { API_ROUTES } from "@/utils/API";
import vueEditorOptions from "@/plugins/vue-editor/options-default";
import CommentImage from "@/modules/Services/Template/views/ActivityLog/assets/comment.svg";

const ICONS = {
  send: "send",
};

@Component
export default class CommentNote extends Vue {
  @Prop({ type: Object, required: true }) readonly note!: TNote_Table;
  @Prop({ type: Number, required: true }) readonly editedIndex!: number;

  icons = ICONS;

  image = CommentImage;

  editorOptions = vueEditorOptions.editorSettingsNoHeader;
  customModulesForEditor = vueEditorOptions.customModulesForEditor;

  get showCommentEdit() {
    return this.editedIndex === this.note.id;
  }

  get caseId() {
    return this.$route.params.id;
  }

  get noteMessage() {
    const startString = this.note.message.substr(0, this.note.message.length - 4);
    const endString = this.note.message.substr(this.note.message.length - 4);

    return this.note.message ? "<span>’</span>" + `<div>${startString}’${endString}</div>` : "";
  }

  editedMessage = this.note.message;

  async saveMessage() {
    const data: TNote = {
      message: this.editedMessage,
    };

    await this.axios.put(API_ROUTES.CASE_ACTIVITY_LOG_EDIT(this.caseId, this.note.id), data);

    this.$emit("finishEditing");
  }
}
